/* eslint-disable no-new */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import EVENTS from '@/utils/Constants/Events';
import Header from '@/components/popup/Header';

import { PdpGalleryControllerClass } from '@/pdp-braun/Controllers/PdpGalleryController';

const ZoomModal = ({ slideNum, content }) => {
  const handleClose = () => {
    const popup = document.querySelector('.dln-popup.dln-popup--open');
    if (popup) {
      DLG.EVE.emit(EVENTS.MODAL.CLOSE, { popup });
    }
  };

  useEffect(() => {
    DLG.EVE.emit(EVENTS.MODAL.OPEN, null, {
      fullSize: 'both',
      scrollOrigin: 'page',
    });
    new PdpGalleryControllerClass({
      selector: '#js-bra-product-gallery-popup #js-bra-prodGallery--zoom',
      slideNum,
    });
    setTimeout(() => {
      document
        .querySelector('#js-bra-product-gallery-popup .dln-popup__head button')
        .focus();
    }, 300);
  }, []);

  return (
    <div
      id='js-bra-product-gallery-popup'
      className='bra-product-gallery-popup'
    >
      <Header closeOnly onClickClose={handleClose} />
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

ZoomModal.propTypes = {
  slideNum: PropTypes.string,
  content: PropTypes.string,
};
ZoomModal.defaultProps = {
  slideNum: '0',
  content: null,
};

class PdpZoomGalleryLoader {
  static load(slideNum) {
    const entry = document.getElementById('js-braun-pdp-zoom');
    if (entry) {
      const content = entry.innerHTML;
      ReactDOM.render(
        <ZoomModal slideNum={slideNum} content={content} />,
        document.getElementById('js-dln-popup__wrapper'),
      );
    }
  }
}

export default PdpZoomGalleryLoader;
